import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/Index'
import Login from '@/page/Login'
import LoginNew from '@/page/LoginNew'
import Regist from '@/page/Regist'
import RegistApp from '@/page/RegistApp'
import UserAgreement from '@/page/UserAgreement'
import PrivacyPolicy from '@/page/PrivacyPolicy'
import PhoneChangePwd from '@/page/PhoneChangePwd'
import EmailChangePwd from '@/page/emailChangePwd'
import EmailSend from '@/page/emailSend'
import Home from '@/page/homeTown'
import AuthStatus from '@/page/system/applet/authStatus'
import {baseInfo} from '@/router/baseInfo.route';
import {system} from '@/router/system.route';
import {store} from '@/router/store.route';
import {delivery} from '@/router/delivery.route';
import {archives} from '@/router/archives.route';
import {wholeasle} from '@/router/wholeasle.route';
import {member} from '@/router/member.route';
import {purchase} from '@/router/purchase.route';
import {retail} from '@/router/retail.route';
import {warehouse} from '@/router/warehouse.route';
import {weigh} from '@/router/weigh.route';
import {settle} from './settle.route';
import {report} from '@/router/report.route';
import {mall} from "@/router/mall.route";
import {promotion} from "@/router/promotion.route";
import {takeout} from '@/router/takeout.route';
import {apply} from '@/router/apply.route';
import weChatSuccess from "../page/system/applet/weChatSuccess";
Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'login',
    component: Index,
    redirect: '/login',
    meta: {
      requireAuth: true
    },
    children: [{
      path: '/index',
      name: 'index',
      component: Home,
      meta: {
        requireAuth: true,
        title: '首页'
      }
    },
      ...baseInfo,
      ...system,
      ...store,
      ...delivery,
      ...archives,
      ...wholeasle,
      ...member,
      ...purchase,
      ...retail,
      ...warehouse,
      ...weigh,
      ...settle,
      ...report,
      ...mall,
      ...promotion,
      ...takeout,
      ...apply,
    ]
  },
    {
      path: '/login',
      name: '/login',
      component: Login
    },
    {
      path: '/system/applet/success',
      name: '小程序授权成功',
      component:AuthStatus
    },
    {
      path: '/system/weChat/success',
      name: '公众号授权成功',
      component:weChatSuccess
    },
    {
      path: '/loginNew',
      name: 'loginNew',
      component: LoginNew
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: UserAgreement
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/regist',
      name: 'regist',
      component: Regist
    },
    {
      path: '/app/regist',
      name: 'appRegist',
      component: RegistApp
    },
    {
      path: '/phone/changePwd',
      name: 'phoneChangePwd',
      component: PhoneChangePwd
    },
    {
      path: '/email/changePwd',
      name: 'emailChangePwd',
      component: EmailChangePwd
    },
    {
      path: '/email/change/password',
      name: 'emailSend',
      component: EmailSend
    }
  ]
});
// 如果通过url登录，则清空localstorage
// const windowUrl = 'http://jarvis.5gzvip.idcfengye.com?username=5555&password=e10adc3949ba59abbe56e057f20f883e&merchantNo=88131416'
const windowUrl = window.location.href
let urlPath = ''
if(windowUrl.indexOf('?')!==-1){
  urlPath = windowUrl.split("?")[1]
}
let reLogin = '/login'
if(windowUrl.indexOf('username')!==-1 || windowUrl.indexOf('password')!==-1||windowUrl.indexOf('merchantNo')!==-1){
  window.localStorage.clear()
  reLogin = null
}
//无需登录可访问的页面
const NotLoggedInPath=[reLogin,'/loginNew','/app/regist','/regist','/userAgreement','/privacyPolicy','/phone/changePwd','/email/changePwd','/email/change/password'];
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '嘉维斯智慧零售';
  }
  var userInfo = window.localStorage.getItem('SYSUSER');
  if (userInfo && to.path == '/login') {
    next('/index');
  }
  else if(!userInfo){
    //是否存在无需登录可访问的页面
    let result = NotLoggedInPath.some(url=>{
      return url == to.path
    })
    if(result){//存在无需登录可访问的页面,则放过
      next();
    }else{//不存在
      NotLoggedInPath.push('/login')
      next('/login?'+urlPath);
    }
  }
  else {
    next();
  }
});
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router;
// else if (!userInfo && NotLoggedInPath.filter(url => {
//   return url == to.path
// }).length == 0) {
//   console.log(to.path)
//   switch (to.path) {
//     case '/regist':
//       next('/regist');
//     default:
//       next('/login');
//       break;
//   }
// }



// WEBPACK FOOTER //
// ./src/router/index.js